import "./LogoGrid.scss";

export default function LogoGrid({ logos }) {
  return (
    <div className="logo-grid">
      {logos.map((logo, index) => (
        <div key={index} className="logo-grid__item">
          <img src={logo} alt={`Logo ${index + 1}`} />
        </div>
      ))}
    </div>
  );
}
